import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { bentoGridStyles } from './BentoGrid.styles';

export type BentoGridProps = {
  children: ReactNode;
  className?: string;
};

export function BentoGrid({ children, className }: BentoGridProps): JSX.Element {
  return <div className={cn(bentoGridStyles.root, className)}>{children}</div>;
}
